import { del, get, post, put } from "../api"
import * as url from "./urls"

const getRequestsTypes = async () => {
  return get(url.SUPPORT_REQUEST_TYPES)
}

const getRequestsStepTypes = async () => {
  return get(url.SUPPORT_REQUEST_STEP_TYPES)
}

const getCheckBoxes = async () => {
  return get(url.GET_CHECKBOXES)
}

const getRequests = (page = 1, filters, limit = 20) => {
  const endpoint = url.SUPPORT_REQUESTS.replace(":page", page)
  return get(endpoint, {
    params: {
      filters,
      limit,
    },
  })
}

const getRequestsAR = orderId => {
  const endpoint = url.GET_REQUEST_AR.replace(":orderId", orderId)
  return get(endpoint)
}

const assignRequest = (id, userId) => {
  const endpoint = url.SUPPORT_REQUESTS_ASSIGN_USER.replace(":id", id).replace(
    ":userId",
    userId
  )
  return post(endpoint)
}

const markAsSolved = id => {
  const endpoint = url.SUPPORT_REQUESTS_RESOLVE.replace(":id", id)
  return post(endpoint)
}

const openSupport = term => {
  return post(url.OPEN_SUPPORT, {
    q: term,
  })
}

const getOpened = () => {
  return get(url.GET_OPENED_SUPPORT)
}

const closeSupport = (supportId, note) => {
  const endpoint = url.CLOSE_SUPPORT.replace(":id", supportId)
  return post(endpoint, { details: note })
}

const createRequest = (action, data, file) => {
  const {
    supportId,
    orderId,
    annotations,
    shippingOrderCode,
    courierId,
    courierName,
    channelId,
    queueId,
    sameAddress,
  } = data
  const endpoint = url.CREATE_REQUEST.replace(":supportId", supportId).replace(
    ":orderId",
    orderId
  )
  const stringfy = JSON.stringify(annotations)
  return post(
    endpoint,
    {
      annotations: stringfy,
      shippingOrderCode,
      courierId,
      courierName,
      channelId,
      queueId,
      action_tag: action,
      sameAddress,
      batch: file,
    },
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  )
}

const moveRequest = body => {
  return post(url.MOVE_REQUEST, body)
}

const moveQueue = body => {
  return post(url.MOVE_QUEUE, body)
}

const markAsSolvedV2 = (id, body) => {
  const endpoint = url.MARK_AS_SOLVED_V2.replace(":id", id)
  return post(endpoint, body)
}

const getRequestInfo = supportRequestId => {
  const endpoint = url.GET_REQUEST_INFO.replace(
    ":supportRequestId",
    supportRequestId
  )
  return get(endpoint)
}

const getRequestSteps = supportRequestId => {
  const endpoint = url.GET_REQUEST_STEPS.replace(
    ":supportRequestId",
    supportRequestId
  )
  return get(endpoint)
}

const postEncerramento = (supportRequestId, details) => {
  const endpoint = url.POST_ENCERRAMENTO.replace(
    ":supportRequestId",
    supportRequestId
  )
  return post(endpoint, {
    details: details,
  })
}

const addNoteToOrder = (id, details) => {
  const endpoint = url.POST_NOTE.replace(":supportRequestId", id)
  return post(endpoint, {
    details: details,
  })
}

const getQueues = () => {
  return get(url.QUEUES)
}

const getRequestsQueueTypes = async () => {
  return get(url.SUPPORT_REQUEST_QUEUES_TYPES)
}

const getAllQueues = () => {
  return get(url.ALL_QUEUES)
}

const getQueue = id => {
  const endpoint = url.GET_QUEUE.replace(":id", id)
  return get(endpoint)
}

const addQueue = (name, roles, shippingCompanyId = null) => {
  return post(url.QUEUES, {
    name: name,
    roles: roles,
    shippingCompanyId: shippingCompanyId,
  })
}

const patchQueue = (id, name, roles, shippingCompanyId = null) => {
  const endpoint = url.PATCH_QUEUE.replace(":id", id)
  return post(endpoint, {
    name: name,
    roles: roles,
    shippingCompanyId: shippingCompanyId,
  })
}

const deleteQueue = id => {
  const endpoint = url.DELETE_QUEUE.replace(":id", id)
  return del(endpoint)
}

const forceDeleteQueue = id => {
  const endpoint = url.FORCE_DELETE_QUEUE.replace(":id", id)
  return del(endpoint)
}

const restoreQueue = id => {
  const endpoint = url.RESTORE_QUEUE.replace(":id", id)
  return post(endpoint)
}

const getChannels = () => {
  return get(url.CHANNELS)
}

const getRequestsChannelTypes = async () => {
  return get(url.SUPPORT_REQUEST_CHANNELS_TYPES)
}

const getAllChannels = () => {
  return get(url.ALL_CHANNELS)
}

const addChannel = (name, shippingModality) => {
  return post(url.CHANNELS, { name: name, shippingModality: shippingModality })
}

const patchChannel = (id, name, shippingModality) => {
  const endpoint = url.PATCH_CHANNEL.replace(":id", id)
  return post(endpoint, { name: name, shippingModality: shippingModality })
}

const deleteChannel = id => {
  const endpoint = url.DELETE_CHANNEL.replace(":id", id)
  return del(endpoint)
}

const forceDeleteChannel = id => {
  const endpoint = url.FORCE_DELETE_CHANNEL.replace(":id", id)
  return del(endpoint)
}

const restoreChannel = id => {
  const endpoint = url.RESTORE_CHANNEL.replace(":id", id)
  return post(endpoint)
}

const getSteps = () => {
  return get(url.STEPS)
}

const getAllSteps = () => {
  return get(url.GET_ALL_STEPS)
}

const addStep = name => {
  return post(url.STEPS, { name: name })
}

const patchStep = (id, name) => {
  const endpoint = url.PATCH_STEP.replace(":id", id)
  return post(endpoint, { name: name })
}

const deleteStep = id => {
  const endpoint = url.DELETE_STEP.replace(":id", id)
  return del(endpoint)
}

const forceDeleteStep = id => {
  const endpoint = url.FORCE_DELETE_STEP.replace(":id", id)
  return del(endpoint)
}

const restoreStep = id => {
  const endpoint = url.RESTORE_STEP.replace(":id", id)
  return post(endpoint)
}

const getSupportRequestType = () => {
  return get(url.SUPPORT_REQUEST_TYPE)
}

const getAllSupportRequestType = () => {
  return get(url.GET_ALL_SUPPORT_REQUEST_TYPE)
}

const getSupportRequestTypeById = id => {
  const endpoint = url.GET_SUPPORT_REQUEST_TYPE_BY_ID.replace(":id", id)
  return get(endpoint)
}

const addSupportRequestType = ({
  name,
  details,
  sla,
  // firstQueueId,
  queues,
  isAuto,
  orderStatus,
  shippingCompanyId = null,
}) => {
  return post(url.SUPPORT_REQUEST_TYPE, {
    name: name,
    tag: name.replace(" ", "_"),
    details: details,
    sla: sla,
    isAuto: isAuto,
    // firstQueueId: firstQueueId,
    queues: queues,
    orderStatus: orderStatus,
    shippingCompanyId: shippingCompanyId,
  })
}

const addSupportRequestTypeAuto = ({
  name,
  details,
  sla,
  isAuto,
  queues,
  failQueue,
  finisherCode,
  orderStatus,
  shippingCompanyId = null,
  workflowTypeId,
}) => {
  return post(url.SUPPORT_REQUEST_TYPE, {
    name: name,
    tag: name.replace(" ", "_"),
    details: details,
    sla: sla,
    isAuto: isAuto,
    queues: queues,
    failQueue: failQueue,
    finisherCode: finisherCode,
    orderStatus: orderStatus,
    shippingCompanyId: shippingCompanyId,
    workflowTypeId: workflowTypeId,
  })
}

const patchSupportRequestType = (
  id,
  {
    name,
    details,
    firstQueueId,
    sla,
    queues,
    orderStatus,
    shippingCompanyId = null,
  }
) => {
  const endpoint = url.PATCH_SUPPORT_REQUEST_TYPE.replace(":id", id)
  return post(endpoint, {
    name: name,
    tag: name.replace(" ", "_"),
    details: details,
    sla: sla,
    // firstQueueId: firstQueueId,
    queues: queues,
    orderStatus: orderStatus,
    shippingCompanyId: shippingCompanyId,
  })
}

const patchSupportRequestTypeAuto = (
  id,
  {
    name,
    details,
    sla,
    isAuto,
    queues,
    failQueue,
    finisherCode,
    orderStatus,
    shippingCompanyId = null,
    workflowTypeId,
  }
) => {
  const endpoint = url.PATCH_SUPPORT_REQUEST_TYPE.replace(":id", id)
  return post(endpoint, {
    name: name,
    tag: name.replace(" ", "_"),
    details: details,
    sla: sla,
    isAuto: isAuto,
    queues: queues,
    failQueue: failQueue,
    finisherCode: finisherCode,
    orderStatus: orderStatus,
    shippingCompanyId: shippingCompanyId,
    workflowTypeId: workflowTypeId,
  })
}

const deleteSupportRequestType = id => {
  const endpoint = url.DELETE_SUPPORT_REQUEST_TYPE.replace(":id", id)
  return del(endpoint)
}

const restoreSupportRequestType = id => {
  const endpoint = url.RESTORE_SUPPORT_REQUEST_TYPE.replace(":id", id)
  return post(endpoint)
}

const viaCEP = cep => {
  const endpoint = url.VIA_CEP.replace(":cep", cep)
  return get(endpoint)
}

const downloadFile = ({ filename }) => {
  const endpoint = url.DOWNLOAD_ATTATCHMENT.replace(":filename", filename)
  return get(endpoint, {
    responseType: "blob",
  })
}

export {
  addChannel,
  addNoteToOrder,
  addQueue,
  addStep,
  addSupportRequestType,
  addSupportRequestTypeAuto,
  assignRequest,
  closeSupport,
  createRequest,
  deleteChannel,
  deleteQueue,
  deleteStep,
  deleteSupportRequestType,
  forceDeleteChannel,
  forceDeleteQueue,
  forceDeleteStep,
  getAllChannels,
  getAllQueues,
  getAllSteps,
  getAllSupportRequestType,
  getChannels,
  getCheckBoxes,
  getOpened,
  getQueue,
  getQueues,
  getRequestInfo,
  getRequestSteps,
  getRequests,
  getRequestsAR,
  getRequestsChannelTypes,
  getRequestsQueueTypes,
  getRequestsStepTypes,
  getRequestsTypes,
  getSteps,
  getSupportRequestType,
  getSupportRequestTypeById,
  markAsSolved,
  markAsSolvedV2,
  moveQueue,
  moveRequest,
  openSupport,
  patchChannel,
  patchQueue,
  patchStep,
  patchSupportRequestType,
  patchSupportRequestTypeAuto,
  postEncerramento,
  restoreChannel,
  restoreQueue,
  restoreStep,
  restoreSupportRequestType,
  viaCEP,
  downloadFile,
}
